<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"
            theme="white"
    ></nav-bar>

    <!-- quick fix for displaying sections -->
    <br><br>
    <!-- End of quick fix for displaying sections -->

    <section class="p-b-5 pt-5">
        <div class="container w-100">
            <div class="row">
                <div class="col-12">
                    <h3 class="aeroviewer-element-container-heading mb-0">AeroViewer Pricing</h3>
                    <p class="aeroviewer-element-container-sub mb-1">Unique Content comes in affordable prices</p>
                </div>
            </div>
        </div>
    </section>

    <section class="bg-master-lightest p-t-25 p-b-95">
        <div class="container w-100">


            <div class="row justify-content-center">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="panel panel-success panel-pricing">
                        <div class="panel-heading text-center" style="border: 1px solid rgba(0,0,0,.125); background: #48b0f7">
                            <i style="color: white; font-size:3em" class="pg-image"></i>
                            <h3 style="color: white"><b>Photo Pricing</b></h3>
                            <h6 style="color: white"><b>Single Asset</b></h6>
                        </div>
                        <ul class="list-group">
                            <li class="list-group-item">
                                <div class="row padding-20">
                                    <div class="col-5"><p><b>HD</b></p></div>
                                    <div class="col-7 text-right">
                                        <ul class="list-unstyled">
                                            <li>size: 5000x3750</li>
                                            <li>DPI: 300</li>
                                        </ul>
                                        <h4>100,00 €</h4>
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item">
                                <div class="row padding-20">
                                    <div class="col-5"><p><b>WEB_LG</b></p></div>
                                    <div class="col-7 text-right">
                                        <ul class="list-unstyled">
                                            <li>size: 1920x1080</li>
                                            <li>DPI: 72</li>
                                        </ul>
                                        <h4>14,00 €</h4>
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item">
                                <div class="row padding-20">
                                    <div class="col-5"><p><b>WEB_MD</b></p></div>
                                    <div class="col-7 text-right">
                                        <ul class="list-unstyled">
                                            <li>size: 1024x576</li>
                                            <li>DPI: 72</li>
                                        </ul>
                                        <h4>9,80 €</h4>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="panel panel-success panel-pricing">
                        <div class="panel-heading text-center" style="border: 1px solid rgba(0,0,0,.125); background: #48b0f7">
                            <i style="color: white; font-size:3em" class="pg-video"></i>
                            <h3 style="color: white"><b>Footage Pricing</b></h3>
                            <h6 style="color: white"><b>Per Second</b></h6>
                        </div>
                        <ul class="list-group">
                            <li class="list-group-item">
                                <div class="row padding-20">
                                    <div class="col-5"><p><b>HD</b></p></div>
                                    <div class="col-7 text-right">
                                        <ul class="list-unstyled">
                                            <li>size: 5000x3750</li>
                                            <li>DPI: 300</li>
                                        </ul>
                                        <h4>2,00 €</h4>
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item">
                                <div class="row padding-20">
                                    <div class="col-5"><p><b>WEB_LG</b></p></div>
                                    <div class="col-7 text-right">
                                        <ul class="list-unstyled">
                                            <li>size: 1920x1080</li>
                                            <li>DPI: 72</li>
                                        </ul>
                                        <h4>0,98 €</h4>
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item">
                                <div class="row padding-20">
                                    <div class="col-5"><p><b>WEB_MD</b></p></div>
                                    <div class="col-7 text-right">
                                        <ul class="list-unstyled">
                                            <li>size: 1024x576</li>
                                            <li>DPI: 72</li>
                                        </ul>
                                        <h4>0,65 €</h4>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <section class="p-b-5 pt-5">
        <div class="container w-100">
            <div class="row">
                <div class="col-12">
                    <h3 class="aeroviewer-element-container-heading mb-0">AeroViewer Bundle Offers</h3>
                    <p class="aeroviewer-element-container-sub mb-1">Save to up 25% with special bundles</p>
                </div>
            </div>
        </div>
    </section>

    <section class="bg-master-lightest p-t-25 p-b-95">
        <div class="container w-100">


            <div class="row justify-content-start">
                <div class="col-sm-12 col-md-12 col-lg-4 aeroviewer-col-element text-center" each="{offer in offers}"  if="{opts.offers.length}">
                    <div class="panel panel-complete panel-pricing" style="border: 1px solid rgba(0,0,0,.125);">
                        <div class="panel-heading" style=" background: #48b0f7">
                            <i style="font-size:3em; color: white" class="fa {pg-image: offer.type === 'photo', pg-video: offer.type === 'video'}"></i>
                            <p class="h3" style="color: white"><b>{offer.name}</b></p>
                        </div>
                        <div class="panel-body text-center">
                            <p class="h4 p-t-30">{offer.description}</p>
                            <p class="hint-text text-black">{offer.discount}% discount</p>
                        </div>
                        <div class="panel-footer padding-5">
                            <button class="btn aero-btn-primary btn-lg w-100"
                                    onclick="{showBundlePriceModal}">
                                purchase
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <section>
        <div class="jumbotron">
            <div class="row" style="text-align: center;">
                <div class="col-sm-4 col-lg-4">
                    <h4 class="p-l-50"> * If none of our plans suits your needs feel free to send us an
                        email at <a class="text-complete"
                                    href="mailto:contact@aeroviewer.com">contact@aeroviewer.com</a>. We will
                        contact you and discuss a custom plan tailored to your needs</h4>
                </div>
                <div class="col-sm-4 col-lg-4">
                </div>
                <div class="col-sm-4 col-lg-4">
                    <h3>Contact Information</h3>
                    <p>E-mail: contact@aeroviewer.com</p>
                </div>
            </div>
        </div>
    </section>

    <price-modal
            offer="{offer}"
            add-to-cart="{addToCart}"
    ></price-modal>

    <avr-footer></avr-footer>


    <script>

        // import components
        import './price-modal.tag.html';
        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';

        // app instance
        const app = this;

        app.parseOffer = (offer) => {
            offer['WEB_LG'] = offer.web_lg;
            offer['WEB_MD'] = offer.web_md;
            offer['HD'] = offer.hd;
            delete offer.hd;
            delete offer.web_lg;
            delete offer.web_md;
            delete offer.digishare;
            return offer
        };

        app.showBundlePriceModal = (event) => {
            event.preventUpdate = true;
            event.preventDefault();
            app.offer = event.item.offer;
            app.update();
            app.tags['price-modal'].toggle();
        };

        app.addToCart = (cartItem) => {
            return app.tags['nav-bar'].addItem(cartItem)
        };

        // app state
        app.offer = {};

        app.offers = (opts.offers || []).map(app.parseOffer);


    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/pricing/app.tag.html